import React, { useState } from "react";
import PropTypes from "prop-types";
import classes from "./DistanceRangePicker.module.css";
import Colors from "../assets/Colors";
import Fonts from "../assets/Fonts";
import { Button } from "../Button/Button";
import { Row, Col } from "react-bootstrap";
import { PriceInput } from "../PriceInput/PriceInput";

import RangePickerWithGraph from "../../components/RangePickerWithGraph/RangePickerWithGraph";

import {
  RangeSlider,
  RangeSliderTrack,
  RangeSliderFilledTrack,
  RangeSliderThumb,
  ChakraProvider,
} from "@chakra-ui/react";
import { RangeSliderIcon } from "../../constant/imagePath";
import { LinkButtonWithIcon } from "../LinkButtonWithIcon/LinkButtonWithIcon";

const RangeArray = [
  6, 6, 6, 6, 6, 28, 28, 48, 48, 60, 60, 60, 48, 48, 28, 28, 6, 6, 6, 6, 20, 20,
  6, 6, 6, 6, 28, 28, 28, 28, 28, 6, 6, 6, 6, 20, 20, 20, 6, 6, 6, 6, 48, 48,
  60, 60, 60, 20, 20, 6,
];

export function DistanceRangePicker({
  value,
  setValue,
  handleDistanceRange,
  containerClass,
  showButtons = true,
}) {
  return (
    <ChakraProvider>
      <div
        className={`${[classes.card, containerClass && containerClass].join(
          " "
        )}`}
      >
        <Row className={`g-0 ${[classes.cardFirstRow].join(" ")}`}>
          <Col md={12}>
            <RangePickerWithGraph
              isMulti={false}
              value={value}
              setValue={setValue}
              min={10}
              max={1000}
            />

            {/*  */}
          </Col>
          <Col md={12}>
            <PriceInput
              state={value}
              setter={setValue}
              customStyle={{ width: "100%" }}
              label={"max distance"}
              type="number"
              postfix="miles"
              maxValueLength={5}
            />
          </Col>
        </Row>
        {/* Buttons Row */}
        <Row>
          <Col md={12}>
            {showButtons && (
              <div
                className={`${[classes.btnsBox].join(" ")}`}
                style={{
                  borderTop: `1px solid ${Colors.neutralShadesOfWhisper}`,
                }}
              >
                <LinkButtonWithIcon
                  text={"Clear"}
                  customStyle={{
                    ...Fonts.b2,
                    lineHeight: "20px",
                  }}
                  textColor={Colors.neutralShadesOfNero}
                  onClick={() => setValue(0)}
                />
                <Button
                  onClick={handleDistanceRange}
                  label={"Save"}
                  primary={true}
                  size={"Medium"}
                  customStyle={{ width: "64px", height: "36px" }}
                />
              </div>
            )}
          </Col>
        </Row>
      </div>
    </ChakraProvider>
  );
}
DistanceRangePicker.propTypes = {
  value: PropTypes.number,
  setValue: PropTypes.func,
};
DistanceRangePicker.defaultProps = {
  value: 100,
};
